import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'
import { ScreeningQuestionResponse } from './actions'

export type ActionType = 'createComment' | 'deleteComment' | ''

type InitialStateType = {
  response: ScreeningQuestionResponse
  fetching: boolean
}

const initialState: InitialStateType = {
  response: {
    data: [],
    org_total_question_count: 0,
    success: false,
    statusCode: 0,
  },
  fetching: false,
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.GET_SCREENING_QUESTIONS_PENDING: {
      return {
        ...state,
        response: {
          ...state.response,
          success: false,
        },
        fetching: true,
      }
    }

    case actions.GET_SCREENING_QUESTIONS_FULFILLED: {
      const url = action?.payload?.config.url
      const isDefaultApi = !url?.includes('search')
      if (!isDefaultApi) {
        state.response.data?.splice(50, 1000, ...(action?.payload?.data?.data ?? []))
      }
      const responseData = isDefaultApi
        ? action?.payload?.data
        : {
            ...action?.payload?.data,
            data: state.response.data,
          }
      return {
        ...state,
        response: responseData ?? initialState.response,
        fetching: false,
      }
    }

    case actions.GET_SCREENING_QUESTIONS_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    default:
      return state
  }
}
